import Choices from './choices';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class SimpleChoices extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.string,
  };

  static defaultProps = {
    onChange: (v) => v,
  };

  handleChange = (outValue) => this.props.onChange(outValue && outValue.value);

  transformValue = (inValue) => ({
    value: inValue,
  });

  render() {
    return (
      <Choices
        {...this.props}
        noneChoice={false}
        other={false}
        onChange={this.handleChange}
        value={this.transformValue(this.props.value)}
      />
    );
  }
}
